import React from 'react';
import { ClientStatus } from '../../model/ClientStatus';
import StadiumMaterialuHistoriaList from '../../model/StadiumMaterialuHistoriaList';
import Uuid from '../../model/Uuid';

export interface StadiumMaterialuHistoriaContextContent {
  stadiumMaterialuHistoria: StadiumMaterialuHistoriaList | undefined,
  stadiumMaterialuHistoriaStatus: ClientStatus | undefined,
  fetchStadiumHistoria: (uuid: Uuid) => void;
}

export default React.createContext<StadiumMaterialuHistoriaContextContent>({
  stadiumMaterialuHistoria: undefined,
  stadiumMaterialuHistoriaStatus: undefined,
  fetchStadiumHistoria: () => { /* noop */ },
});
